module.exports = __webpack_public_path__ + "static/media/3B073E_1_0.00916fe0.woff2";